import axios from 'axios'

/**
 * 获取IP定位信息（通过百度地图API）
 * @returns {Promise} 包含status、province、city的对象
 */
export function getIpLocation() {
    return axios.get('https://ip.nixiaofeng.com/baidu-location')
    .then(response => {
        const { content } = response.data;
        const { status } = response.data;
        return {
            status: !status,
            province: content.address_detail.province,
            city: content.address_detail.city,
        };
    });
}

/**
 * 动态加载百度地图SDK脚本
 * @param {string} ak - 百度地图AK
 * @returns {Promise} 百度地图GL对象
 */
export function loadBaiduMapScript(ak) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://api.map.baidu.com/api?type=webgl&v=1.0&ak=${ak}&callback=onBMapCallback`
        script.onerror = reject
        window.onBMapCallback = () => {
            resolve(BMapGL)
        }
        document.head.appendChild(script)
    })
}
